import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'eng-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class EngineerAppComponent {
  title = 'engineer';
  public unsupportedBrowser = false;
  public supportedBrowsers = ['chrome', 'edge', 'safari'];
  constructor(private readonly deviceService: DeviceDetectorService){
    
  }
  public ngOnInit(): void {
    const browserName = this.deviceService.browser.toLowerCase();
    this.unsupportedBrowser = !this.supportedBrowsers.some(browser =>
      browserName.includes(browser)
    );}
}
